import { FormSize } from "../../../view-model";
export const defaultSize = FormSize.MD;
export const defaultReadOnly = false;
export const defaultDisabled = false;
export const createFormCommon = formCommon => {
  var _formCommon$size, _formCommon$readOnly, _formCommon$disabled;
  return {
    size: (_formCommon$size = formCommon.size) !== null && _formCommon$size !== void 0 ? _formCommon$size : defaultSize,
    readOnly: (_formCommon$readOnly = formCommon.readOnly) !== null && _formCommon$readOnly !== void 0 ? _formCommon$readOnly : defaultReadOnly,
    disabled: (_formCommon$disabled = formCommon.disabled) !== null && _formCommon$disabled !== void 0 ? _formCommon$disabled : defaultDisabled
  };
};
export const createEmptyFormCommon = () => ({
  size: defaultSize,
  readOnly: defaultReadOnly,
  disabled: defaultDisabled
});